import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .justify-space-between {
    justify-content: space-between;
  }

  .wrap {
    flex-wrap: wrap;
  }

  .col {
    display: flex;
    flex-direction: column;
  }

  .title-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: no-wrap;
    justify-content: space-between;
  }

  .block-title {
    margin-bottom: 0;
    margin-left: 20px;
    margin-right: 5px;
  }

  .approved-icon {
    width: 22px;
    height: 22px;
    margin-left: -15px;
    margin-top: -30px;
  }

  .info-text-container {
    margin-top: 16px;
    margin-left: 68px;

    h6 {
      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
    }

    .info-text {
      margin-bottom: 0;
    }
  }

  .info-text {
    font-size: 12px;
    line-height: 1.67;
    color: ${({ theme }) => theme.colors.gray.color};
  }

  .error-text {
    font-size: 12px;
    line-height: 1.67;
    color: ${({ theme }) => theme.colors.error.color};
  }

  .success-text {
    font-size: 12px;
    line-height: 1.67;
    color: ${({ theme }) => theme.colors.success.color};
  }

  .btn-wrapper-small {
    display: none;
  }

  .btn-cancel {
    height: auto;
    min-height: 50px;
  }

  @media (max-width: ${Breakpoints.maxExtraSmall}) {
    .title-row {
      flex-wrap: wrap;
    }

    .title-col {
      margin-top: 10px;
      width: 100%;
      align-items: center;
    }

    .info-text-container {
      margin-left: 0;
      text-align: center;
    }

    .btn-wrapper {
      display: none;
    }

    .btn-wrapper-small {
      display: block;
    }
  }
`;
